import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { PageCardheadComponent } from '../pageheader-card/pageheader-card.component';

@Component({
  selector: 'app-lms-modal-frame',
  standalone: true,
  templateUrl: './lms-modal-frame.component.html',
  styleUrls: ['./lms-modal-frame.component.scss'],
  imports: [NgIf, PageCardheadComponent],
})
export class LmsModalFrameComponent {
  private static readonly MIN_WIDTH_FLOOR_PX = 500;

  @Input() title = '';
  @Input() pageHeadWidth = 650;
  @Input() minWidth: number | string | null = null;
  @Input() maxWidth: number | string | null = null;

  get cssMinWidth(): string {
    return this.toMinCssSize(this.minWidth);
  }

  get cssMaxWidth(): string {
    return this.toCssSize(this.maxWidth ?? '100%');
  }

  private toCssSize(value: number | string | null): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    return typeof value === 'number' ? `${value}px` : value;
  }

  private toMinCssSize(value: number | string | null): string {
    if (typeof value === 'number') {
      return `${Math.max(value, LmsModalFrameComponent.MIN_WIDTH_FLOOR_PX)}px`;
    }

    return this.toCssSize(value);
  }
}
